<adaa-adaa4-stepper [current]="2" [notificationId]="id()" />

@if (loaded()) {
    @if (notification(); as n) {
        <section class="object-head panel">
            <p class="object-eyebrow">
                <span class="chip chip--{{ actionType() }}">
                    @if (actionType() === "other") {
                        {{ AdaaHelper.getItemValueByToken(n, "itemTypeName") }}
                    } @else {
                        {{ "adaa4.action_" + actionType() | translate }}
                    }
                </span>
                @if (actionType() !== "other") {
                    {{ AdaaHelper.getItemValueByToken(n, "itemTypeName") }}
                }
            </p>
            <h1 class="object-title">{{ AdaaHelper.getItemValueByToken(n, "itemName") || AdaaHelper.getItemValueByToken(n, "title") }}</h1>
            <dl class="object-meta">
                <div>
                    <dt>{{ "adaa4.notification.title" | translate }}</dt>
                    <dd>{{ AdaaHelper.getItemValueByToken(n, "title") }}</dd>
                </div>
                <div>
                    <dt>{{ "common.form.label.date" | translate }}</dt>
                    <dd>{{ moment(n.createTS).format("DD/MM/YYYY HH:mm") }}</dd>
                </div>
                <div>
                    <dt>{{ "workflow.workflow_process_id" | translate }}</dt>
                    <dd>{{ n.wfProcessCtlId }}</dd>
                </div>
                @if (isPending()) {
                    <div>
                        <dt>{{ "adaa4.notification.pending_for" | translate }}</dt>
                        <dd>
                            <span class="pending pending--{{ pendingTone() }}">
                                @if (pendingDays() === 0) {
                                    {{ "adaa4.notification.today" | translate }}
                                } @else if (pendingDays() === 1) {
                                    {{ "adaa4.notification.day" | translate }}
                                } @else {
                                    {{ "adaa4.notification.days" | translate: { n: pendingDays() } }}
                                }
                            </span>
                        </dd>
                    </div>
                }
            </dl>
        </section>

        @if (actionType() === "delete") {
            <p class="notice notice--danger" role="note">{{ "adaa4.notification.delete_warning" | translate }}</p>
        }

        <section class="panel">
            <div class="message text-break" [innerHTML]="AdaaHelper.getItemValueByToken(n, 'commMsg')"></div>
            @if (canReview() && isAgreementFile()) {
                <button type="button" class="btn btn--ghost btn--sm" (click)="downloadAgreement()">
                    {{ "communication.view_differences" | translate }}
                </button>
            }
        </section>

        @if (showsDifferences()) {
            <section class="panel">
                <div class="section-head">
                    <h2 class="section-title">{{ workflowDifference.titleKey() | translate }}</h2>
                    @if (canShowOnlyDifferences() && !workflowDifference.isForecastedValues()) {
                        <label class="switch">
                            <input
                                type="checkbox"
                                [checked]="workflowDifference.viewOnlyDifferences()"
                                (change)="workflowDifference.viewOnlyDifferences.set($any($event.target).checked)"
                            />
                            <span class="switch-track" aria-hidden="true"></span>
                            {{ "adaa4.notification.show_only_changes" | translate }}
                        </label>
                    }
                </div>
                <div class="container-fluid">
                    <ng-container [ngTemplateOutlet]="workflowDifference.body()" />
                </div>
            </section>
        }

        @if (history().length) {
            <section class="panel">
                <h2 class="section-title">{{ "workflow.workflow_history" | translate }}</h2>
                <div class="comments-list">
                    @for (step of history(); track step.id) {
                        <article class="comment">
                            <header>
                                <strong>{{ AdaaHelper.getItemValueByToken(step, "approverName") }}</strong>
                                <time>{{ moment(step.updateTS).format("DD/MM/YYYY HH:mm") }}</time>
                            </header>
                            @if (AdaaHelper.getItemValueByToken(step, "workflowStageName"); as stage) {
                                <span class="comment-stage">{{ stage }}</span>
                            }
                            @if (step.comments) {
                                <p>{{ step.comments }}</p>
                            }
                            @for (categorized of step.categorizedComments; track categorized.id) {
                                <p>
                                    <span class="comment-stage">{{ AdaaHelper.getItemValueByToken(categorized, "categoryName") }}</span>
                                    {{ categorized.comments }}
                                </p>
                            }
                        </article>
                    }
                </div>
            </section>
        }

        <div class="action-bar">
            <a class="btn btn--ghost" routerLink="/homepage/notifications">{{ "common.form.button.close" | translate }}</a>
            @if (isPending()) {
                <a class="btn btn--primary" [routerLink]="['/homepage/notifications', id(), 'action']">
                    {{ "adaa4.notification.next" | translate }}
                    <span class="btn-arrow" aria-hidden="true">→</span>
                </a>
            }
        </div>
    } @else {
        <section class="panel empty-state">
            <p>{{ "adaa4.notification.not_found" | translate }}</p>
            <a class="btn btn--ghost" routerLink="/homepage/notifications">{{ "adaa4.notification.back_to_list" | translate }}</a>
        </section>
    }
}

<adaa-wf-difference [isAuditTrail]="notification()?.commType === 'I'" #workflowDifference />
